import sbjs from 'sourcebuster';
import { retrieveUserId, retrieveAnonId } from './cookies';

const keyNameMap = {
  typ: 'trafficType',
  src: 'utmSource',
  mdm: 'utmMedium',
  cmp: 'utmCampaign',
  cnt: 'utmContent',
  trm: 'utmTerm',
  fd: 'timestamp',
  ep: 'entrancePoint',
  rf: 'referrerUrl',
  pgs: 'lastSessionPagesViewed',
  cpg: 'currentPageUrl',
  vst: 'visitsToSiteAllTime',
  uip: 'ipAddress',
  uag: 'userAgent',
};

const buildVisitData = (rawData, initialObject) => {
  return Object.keys(rawData).reduce((obj, key) => {
    let outputData;
    const outputKeyName = keyNameMap[key];

    // Handle sourcebuster's strange choice of '(none)' for null values
    if (rawData[key] === '(none)') {
      outputData = null;
    } else if (outputKeyName === 'timestamp' && rawData[key]) {
      outputData = new Date(rawData[key]).getTime();
    } else {
      outputData = rawData[key];
    }

    return Object.assign({}, obj, { [outputKeyName]: outputData });
  }, initialObject);
};

export const normalizeVisitData = (mainData, additionalData) => {
  const visitData = buildVisitData(mainData, {});

  if (!additionalData) return visitData;

  return buildVisitData(additionalData, visitData);
};

export const getAnonymousId = () => {
  if (window.analytics && window.analytics.user) {
    return window.analytics.user().anonymousId();
  }
  return retrieveAnonId();
};

const getVisitsData = () => ({
  initial: normalizeVisitData(sbjs.get.current, sbjs.get.current_add),
  last: normalizeVisitData(sbjs.get.first, sbjs.get.first_add),
  session: normalizeVisitData(sbjs.get.session),
  userData: normalizeVisitData(sbjs.get.udata),
  userId: retrieveUserId(),
  anonymousId: getAnonymousId(),
});

export default getVisitsData;
